/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ReactionsAPI extends ApiClient {
  constructor() {
    super('wasapi/conversations', { accountScoped: true });
  }

  react(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/reactions`,
      { emoji }
    );
  }
}

export default new ReactionsAPI();
